import { render, staticRenderFns } from "./MyActivitiesHub.vue?vue&type=template&id=604cdc6c&scoped=true"
import script from "./MyActivitiesHub.vue?vue&type=script&lang=js"
export * from "./MyActivitiesHub.vue?vue&type=script&lang=js"
import style0 from "./MyActivitiesHub.vue?vue&type=style&index=0&id=604cdc6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "604cdc6c",
  null
  
)

export default component.exports